import wordmark from '../../assets/wordmark.svg';
import reversed from '../../assets/wordmark-reversed.svg';

export function Brand() {
  return (
    <span className="block">
      <img src={wordmark} alt="Avala" className="h-auto w-[120px] dark:hidden" />
      <img src={reversed} alt="Avala" className="hidden h-auto w-[120px] dark:block" />
    </span>
  );
}
